import { Helmet } from 'react-helmet-async'

const SITE_URL = 'https://www.tredextechnology.in'
const SITE_NAME = 'TRED-EX AI'
const DEFAULT_IMAGE = '/icons.svg'

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  noIndex = false,
  structuredData,
  children,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL
  const imageUrl = image ? `${SITE_URL}${image}` : undefined

  return (
    <Helmet>
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <title>{fullTitle}</title>
      <meta name="description" content={description || ''} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || ''} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || ''} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}

      {children}
    </Helmet>
  )
}

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/icons.svg`,
  contactPoint: [
    {
      '@type': 'ContactPoint',
      email: 'support@tredextechnology.in',
      contactType: 'sales',
    },
    {
      '@type': 'ContactPoint',
      email: 'business@tredextechnology.in',
      contactType: 'business',
    },
  ],
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Chennai',
    addressRegion: 'Tamil Nadu',
    addressCountry: 'IN',
  },
  sameAs: ['https://linkedin.com/company/tredextechnology'],
}

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
}

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url ? `${SITE_URL}${item.url}` : undefined,
  })),
})

export const productSchema = (product) => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: product.name,
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  offers: {
    '@type': 'Offer',
    price: product.price.replace('₹', '').replace(',', ''),
    priceCurrency: 'INR',
  },
  description: product.desc,
  url: product.url ? `${SITE_URL}${product.url}` : undefined,
})
